/* eslint-disable indent */
import { useEffect, useState } from 'react';
import format from 'date-fns/format';
import Text from '../../atoms/Text';
import { StorageKeys } from '../../helpers/localStorage';
import { timeDistance } from '../DexTrades/formatters';

type Log = {
  kind: string;
  dismissAfter: number;
  id: number;
  message: string;
};

const getMessageColor = (type: string) => {
  switch (type) {
    case 'info':
      return 'navy-600';
    case 'warning':
      return 'orange-700';
    default:
      return 'grey--400';
  }
};

const LogsBlock = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const savedLogs =
      window.sessionStorage.getItem(StorageKeys.notifications_log) || '[]';
    setLogs(JSON.parse(savedLogs));
  }, []);

  return (
    <div className='logs'>
      {logs.map((log: Log) => {
        const logDistance =
          timeDistance(log.id) === 'less than'
            ? timeDistance(log.id) + ' minute'
            : timeDistance(log.id);
        return (
          <div className='logs__group' key={log.id}>
            <div className='logs__group__title'>
              <Text
                size={12}
                className={`text--${getMessageColor(
                  log.kind
                )} text--wegight-600`}
              >
                {log.kind.toLocaleLowerCase()}
              </Text>
              <Text size={12} className='text--grey-600'>
                &nbsp;&bull; {logDistance} ago
              </Text>
            </div>
            <div
              className='logs__group__message'
              // onClick={() => window.open(item.Link, '_blank')}
            >
              <Text size={14} className='text--grey-200 text--weight-600'>
                {log.message}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LogsBlock;
